import { render, staticRenderFns } from "./SelectUnit.vue?vue&type=template&id=4c80a1a2&scoped=true&"
import script from "./SelectUnit.vue?vue&type=script&lang=js&"
export * from "./SelectUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c80a1a2",
  null
  
)

export default component.exports